<template>
  <div class="section">
    <b-container>
      <puls-card-header
        class="text-light"
        :left-action="{ to: { name: 'Home', title: $t('navbar.help_home') } }"
        :title="sectionTitle"
      >
      </puls-card-header>
      <Search />
      <b-row>
        <b-col>
          <div class="d-flex flex-column gap-6">
            <div class="row gap-6 gap-md-0">
              <div class="col-12 col-md-4">
                <b-card
                  :img-src="firstArticle.thumbnail"
                  class="first-article-image border-0"
                  img-alt="Image"
                  img-top
                >
                  <puls-navigation-list :items="[firstArticle]" />
                </b-card>
              </div>
              <div class="col-12 col-md-8">
                <b-card v-if="levelTwoArticles.length" class="border-0">
                  <puls-navigation-list
                    :max-text-length="220"
                    :items="levelTwoArticles"
                  />
                </b-card>
              </div>
            </div>
            <b-card v-if="levelThreeArticles.length" class="border-0">
              <puls-navigation-list :items="levelThreeArticles" />
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import en from '../locales/en'
import Search from '../components/Search'
const removeMd = require('remove-markdown')
const thirdStart = 5
export default {
  name: 'Section',
  components: { Search },
  data: () => {
    return {}
  },
  methods: {
    removeMarkdown(text) {
      return removeMd(text)
    }
  },
  computed: {
    sectionName() {
      return this.$route.params.section
    },
    sectionTitle() {
      return this.$t(`home.sections.${this.sectionName}.title`)
    },
    firstArticle() {
      return this.articles[0]
    },
    levelTwoArticles() {
      return this.articles.slice(1, thirdStart)
    },
    levelThreeArticles() {
      return this.articles.slice(thirdStart, this.articles.length)
    },
    articles() {
      return Object.keys(en.home.sections[this.sectionName].articles)
        .map((articleKey) => {
          const o = {
            key: articleKey,
            title: this.$t(
              `home.sections.${this.sectionName}.articles.${articleKey}.title`
            ),
            text: this.removeMarkdown(
              this.$t(
                `home.sections.${this.sectionName}.articles.${articleKey}.body`
              )
            ),
            to: {
              name: 'Article',
              params: { section: this.sectionName, article: articleKey }
            }
          }
          if (en.home.sections[this.sectionName].articles[articleKey].rank) {
            o.rank = this.$t(
              `home.sections.${this.sectionName}.articles.${articleKey}.rank`
            )
          }
          if (
            en.home.sections[this.sectionName].articles[articleKey].thumbnail
          ) {
            o.thumbnail = this.$t(
              `home.sections.${this.sectionName}.articles.${articleKey}.thumbnail`
            )
          }
          return o
        })
        .sort((a, b) => {
          return a.rank - b.rank
        })
    }
  }
}
</script>

<style scoped>
h4.first-article-heading {
  font-size: 22px;
}
p.first-article-text {
  font-size: 18px;
  line-height: 26px;
}
.first-article-image > .card-img-top {
  height: 300px;
  object-fit: cover;
}

h4 {
  font-size: 18px;
  font-weight: 400;
}
.markdown-body {
  color: gray;
}

.article-item {
  border-bottom: 1px solid #eee;
}
</style>
